<template>
  <button
    class="app-text-btn"
    :type="type"
    :disabled="disabled"
    v-bind="$attrs"
    v-on="$listeners">
    <AppIcon
      v-if="icon && iconPosition === 'left'"
      class="app-text-btn__icon"
      :icon="icon"
      :size="iconSize" />
    <span class="app-text-btn__label">
      <slot>{{ label }}</slot>
    </span>
    <AppIcon
      v-if="icon && iconPosition === 'right'"
      class="app-text-btn__icon"
      :icon="icon"
      :size="iconSize" />
  </button>
</template>

<script>
import AppIcon from './AppIcon.vue'

export default {
  name: 'AppTextButton',
  components: {
    AppIcon
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    iconPosition: {
      type: String,
      default: 'left',
      validator: value => ['left', 'right'].includes(value)
    },
    iconSize: {
      type: [String, Number],
      default: 18
    },
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.app-text-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: transparent;
  font-size: var(--app-font-size-base, 1rem);
  font-weight: 600;
  color: var(--app-primary, #0f2835);
  cursor: pointer;
  line-height: var(--app-line-height, 1.5);
  transition: opacity 0.15s ease;
}

.app-text-btn:hover:not(:disabled) {
  filter: brightness(0.9);
}

.app-text-btn:focus {
  outline: none;
  box-shadow: none;
}

.app-text-btn:focus-visible {
  outline: 2px solid var(--app-primary, #0f2835);
  outline-offset: 2px;
}

.app-text-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.app-text-btn__icon {
  flex-shrink: 0;
}
</style>
